

type GetConstructorArgs<T> = T extends new (...args: infer U) => any ? U : never;
type NonFunctionProperties<T> = Pick<T, {
	[K in keyof T]: T[K] extends Function ? never : K;
}[keyof T]>;

type Constructor<T> = { new(...args: any[]): T };

export namespace ObjectUtils {
	export function deepCopy<T>(input: T) {
		if (input === null || input === undefined) {
			return input as T;
		} else if (typeof input === "object") {
			if (Array.isArray(input)) {
				input = input.map((x) => deepCopy(x)) as any;
			} else {
				let output: any = {};
				for (const key in input) {
					if (Object.prototype.hasOwnProperty.call(input, key)) {
						const value = input[key];
						output[key] = deepCopy(value);
					}
				}
				input = output;
			}
		}
		return input as T;
	}

	/** Construct an object of type T and assign data to it */
	export function from<T>(
		target: Constructor<T>,
		data: Partial<NonFunctionProperties<T>>,
		...args: GetConstructorArgs<Constructor<T>>
	) {
		return Object.assign(new target(...args), data) as T;
	}

	/** Construct an object of type T and assign JSON data to it */
	export function fromJSON<T>(
		target: Constructor<T>,
		data: string,
		...args: GetConstructorArgs<Constructor<T>>
	) {
		return from(target, JSON.parse(data), ...args);
	}
}
